import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
    Authenticator,
    Image,
    Text,
    useTheme,
    View,
    ThemeProvider
} from '@aws-amplify/ui-react';
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

// Import the Amplify configuration
import { config } from './config/amplify-config';

// Import custom components
import { LanguageProvider, useLanguage } from './components/LanguageProvider';
import { AuthenticatedHome } from './components/AuthenticatedHome';
import { ConfirmUserPage } from './components/ConfirmUserPage';
import { useAuthServices } from './hooks/useAuthServices';

// Configure Amplify
Amplify.configure(config);

// Configure Cookie Storage for subdomain sharing
const cookieStorage = new CookieStorage({
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
    path: '/',
    expires: 7,
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
});
cognitoUserPoolsTokenProvider.setKeyValueStorage(cookieStorage);

// Authenticator components
const components = {
    Header() {
        const { tokens } = useTheme();

        return (
            <View textAlign="center" padding={tokens.space.large}>
                <Image
                    alt="YOLO JAPAN logo"
                    src="https://www.yolo-japan.com/assets/images/base/logo_header.png?v202407251030"
                />
            </View>
        );
    },

    Footer() {
        const { tokens } = useTheme();

        return (
            <View textAlign="center" padding={tokens.space.large}>
                <Text color={tokens.colors.neutral[80]}>
                    &copy; 2024 YOLO JAPAN.
                </Text>
            </View>
        );
    },
};

// Main App Content Component
const AppContent = () => {
    const { language } = useLanguage();
    const { handleSignIn } = useAuthServices();

    // Authenticator services
    const services = {
        handleSignIn
    } as const;

    return (
        <View>
            <Authenticator
                key={language}
                loginMechanisms={['email']}
                // socialProviders={['google']}
                components={components}
                services={services}
                hideSignUp={true}
            >
                {() => (
                    <AuthenticatedHome />
                )}
            </Authenticator>
        </View>
    );
}

// Main App Component
const App = () => {
    return (
        <ThemeProvider>
            <LanguageProvider>
                <Authenticator.Provider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/confirm-user" element={<ConfirmUserPage />} />
                            <Route path="/" element={<AppContent />} />
                        </Routes>
                    </BrowserRouter>
                </Authenticator.Provider>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;